var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2056,
    height: 545,
    viewBox: "0 0 2056 545",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1874.42 405.461C1465.89 579.755 662.432 363.433 280.362 244.147H0V297.919C1211.02 610.04 1492.84 592.116 1874.42 433.274V405.461Z",
    fill: "#E0E0E0",
    fillOpacity: 0.34
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1936.75 317.609C1526.28 494.333 799.722 235.427 349.679 109.799L69.4277 102.575L67.4807 156.445C1266.72 500.34 1548.56 494.772 1935.74 345.473L1936.75 317.609Z",
    fill: "#E0E0E0",
    fillOpacity: 0.34
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2049.54 215.034C1639.07 391.757 912.513 132.851 462.47 7.22419L182.219 0L180.272 53.8694C1379.51 397.765 1661.35 392.197 2048.53 242.898L2049.54 215.034Z",
    fill: "#E0E0E0",
    fillOpacity: 0.34
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.796818defb6a1579c4c0ab63b4a6dac2.svg";
export { ForwardRef as ReactComponent };